import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import logostarcastnews from '../assets/logostarcastnews.png';
import { getAllMainDocument } from '../services/userApi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Add this import
import { faCheck,faDownload } from '@fortawesome/free-solid-svg-icons';
import backgroundImage from '../assets/Frame_67.jpg';
import { width } from '@fortawesome/free-regular-svg-icons/faAddressBook';


const MySwal = withReactContent(Swal);

const DowloadFile = () => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1); // หมายเลขหน้าปัจจุบัน
    const [pageSize] = useState(5); // ขนาดของข้อมูลต่อหน้า
    const [totalPages, setTotalPages] = useState(10); // จำนวนหน้าทั้งหมด
    const [loading, setLoading] = useState(true); // สถานะการโหลดข้อมูล    
    const [documents, setDocuments] = useState([]); // เก็บข้อมูลคอมเมนต์
    const [downloadedFiles, setDownloadedFiles] = useState({});

    const onError = (title,response) => {
        MySwal.fire({
            title: title,
            html: response?.data?.error?.message,
            icon: "error",
            confirmButtonText: "Close",
            allowOutsideClick: false,
        }).then(async (result) => {
          if (result.isConfirmed) {
              if(response?.status===401) {
                  sessionStorage.removeItem('hasVisited');
                  sessionStorage.removeItem('lastPath');        
                  localStorage.removeItem('account');                  
                  navigate('/');
              };
          }
        });
    };

    const handleDownload = (fileUrl) => {
        // อัปเดตสถานะการดาวน์โหลด
        setDownloadedFiles(prev => ({ ...prev, [fileUrl]: true }));
    };
    

    const loadDocuments = async () => {
        setLoading(true);
    
        try {
            const response = await getAllMainDocument(currentPage, pageSize);
            console.log("API Response:", response);  // เพิ่ม log เพื่อดูผลลัพธ์จาก API
            if (response && response.status === true && response.data && Array.isArray(response.data.main_documents)) {
                setDocuments(response.data.main_documents); // อัพเดตผลลัพธ์
                setTotalPages(response.data.total_page); // อัพเดตจำนวนหน้า
            } else {
                throw new Error('Invalid data structure');
            }
        } catch (error) {
            console.error('Error fetching documents:', error);
            // เพิ่มการแสดงผลของข้อผิดพลาด
            onError('Error', error?.response || { data: { error: { message: 'An unexpected error occurred' } } });
        } finally {
            setLoading(false);
        }
    };
    
    
        // ดึงข้อมูลคอมเมนต์เมื่อ currentPage หรือ pageSize เปลี่ยน
        useEffect(() => {
            loadDocuments(); // โหลดข้อมูลใหม่เมื่อเปลี่ยนหน้า หรือ pageSize
        }, [currentPage, pageSize]);

    const getPaginationItems = () => {
        const pages = [];
        const maxPagesToShow = 5;
        const halfMaxPagesToShow = Math.floor(maxPagesToShow / 2);

        let startPage = Math.max(1, currentPage - halfMaxPagesToShow);
        let endPage = Math.min(totalPages, currentPage + halfMaxPagesToShow);

        if (currentPage - halfMaxPagesToShow <= 0) {
            endPage = Math.min(totalPages, endPage + (halfMaxPagesToShow - currentPage + 1));
        }

        if (currentPage + halfMaxPagesToShow >= totalPages) {
            startPage = Math.max(1, startPage - (halfMaxPagesToShow - (totalPages - currentPage)));
        }

        for (let page = startPage; page <= endPage; page++) {
            pages.push(page);
        }

        return pages;
    };

    const onPageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page); // อัปเดต currentPage
            console.log("Page changed to:", page); // Debug log
        }
    };
    return(
        <>
            <div style={styles.background}></div>
            <div style={styles.container}>
            {documents.map((document, index) => (
            <div
                key={`document-${document.uid}`}
                style={styles.contentDowload}
            >
                <p style={{fontSize:'1vw',fontWeight:'bold',marginTop:0 , marginBottom:'16px'}}>{document.chapter}</p>
                    <div style={styles.DowloadDoc}>
                    {document.files.map((file, fileIndex) => (
                        <div key={`file-${fileIndex}`} style={{ display: 'flex', alignItems: 'center', gap: '16px',paddingBottom:'16px' }}>
                            <FontAwesomeIcon
                                icon={downloadedFiles[file.url] ? faCheck : faDownload}
                                style={{
                                    color: downloadedFiles[file.url] ? 'green' : 'white',
                                    background: downloadedFiles[file.url] ? '#2187304D' : '#44526E',
                                    border: `2px solid ${downloadedFiles[file.url] ? '#218730' : '#44526E'}`,
                                    borderRadius: '1000px',
                                    fontSize: '21.26px',
                                    padding: '10px',
                                }}
                            />
                            <a
                                href={file.url}
                                style={{
                                    textDecoration: 'none',
                                    color: '#000000',
                                    fontSize: '1vw',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                }}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => handleDownload(file.url)}
                            >
                                {file.filename}
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        ))}

            </div>
              {/* Pagination Section */}
              <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div style={styles.pagination}>
                        <span
                            style={{
                                ...styles.paginationItem,
                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                color: currentPage === 1 ? '#ccc' : 'white',
                                fontSize: '30px',
                                textDecoration: 'none',
                            }}
                            onClick={() => onPageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            &lt;
                        </span>
                        {getPaginationItems().map((page) => (
                            <span
                                key={page}
                                style={{
                                    ...styles.paginationItem,
                                    ...(currentPage === page
                                        ? styles.activePaginationItem
                                        : {}),
                                }}
                                onClick={() => onPageChange(page)}
                            >
                                {page}
                            </span>
                        ))}
                        <span
                            style={{
                                ...styles.paginationItem,
                                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                color: currentPage === totalPages ? '#ccc' : 'white',
                                fontSize: '30px',
                                textDecoration: 'none',
                            }}
                            onClick={() => onPageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            &gt;
                        </span>
                    </div>
                </div>
        </>
    )
};

const styles ={
    background: {
        position: 'fixed',
        width: '100%',
        height: '100%',
        top: '0',
        left: '0',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        zIndex: '-1',
    },
    container: {
        paddingTop: '110px',
        width: '90%',
        boxSizing: 'border-box',
        display: 'flex',              // Enable flexbox layout
        flexDirection: 'column',      // Stack items vertically
        justifyContent: 'center',     // Center vertically
        alignItems: 'center',         // Center horizontally
        margin: '0 auto',             // Center the container horizontally
        gap:'16px'
    },    
    pagination: {
        display: 'flex',
        justifyContent: 'center',  // จัดให้อยู่ตรงกลางในแนวนอน
        alignItems: 'center',  // จัดให้อยู่ตรงกลางในแนวตั้ง
        margin: '20px 0',  // เพิ่มระยะห่างจากตาราง
        background: 'linear-gradient(90deg, #7C93B7 0%, #374151 100%)',
        width: '80%',
        borderRadius: '64px',  // เพิ่มขอบมนเล็กน้อยให้กับ pagination
        boxSizing: 'border-box',  // ทำให้ขนาดกล่องรวม padding และ border
    },
    
    paginationItem: {
        margin: '0 20px',
        cursor: 'pointer',
        fontSize: '16px',
        color: 'white',
        textDecoration: 'none',
    },    
    activePaginationItem: {
        backgroundColor: '#44526E',
        color: 'white',
        width: '100%',
        maxWidth:'56px',
        height:'56px',
        borderRadius: '34px',  
        padding: '5px',
        fontSize: '24px',
        textAlign:'center',
        display: 'flex',
        justifyContent: 'center',  // จัดให้อยู่ตรงกลางในแนวนอน
        alignItems: 'center',  // จัดให้อยู่ตรงกลางในแนวตั้ง
    },
    DowloadDoc:{
        textAlign: 'left',
        backgroundColor: '#f2f2f2',
        border: '1px solid #dddddd',
        borderRadius: '16px',
        padding:'24px',
        
    },
    contentDowload:{
        backgroundColor: '#f2f2f2',
        border: '1px solid #dddddd',
        padding:'24px',
        width:'100%',
        textAlign:'left',
        borderRadius: '16px',
    }
}


export default DowloadFile;
